/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_PublicInputs */

const en_community_invite_public = /** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Access`)
};

const id_community_invite_public = /** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Publik`)
};

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const es_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const fr_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const de_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const ja_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const zh_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const ar_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const it_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const ru_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const pt_community_invite_public = en_community_invite_public;

/** @type {(inputs: Community_Invite_PublicInputs) => LocalizedString} */
const ko_community_invite_public = en_community_invite_public;

/**
* | output |
* | --- |
* | "Public Access" |
*
* @param {Community_Invite_PublicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_public = /** @type {((inputs?: Community_Invite_PublicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_PublicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_public(inputs)
	if (locale === "es") return es_community_invite_public(inputs)
	if (locale === "fr") return fr_community_invite_public(inputs)
	if (locale === "de") return de_community_invite_public(inputs)
	if (locale === "ja") return ja_community_invite_public(inputs)
	if (locale === "zh") return zh_community_invite_public(inputs)
	if (locale === "ar") return ar_community_invite_public(inputs)
	if (locale === "id") return id_community_invite_public(inputs)
	if (locale === "it") return it_community_invite_public(inputs)
	if (locale === "ru") return ru_community_invite_public(inputs)
	if (locale === "pt") return pt_community_invite_public(inputs)
	return ko_community_invite_public(inputs)
});